import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = ({ onLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const [shakeError, setShakeError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [requiereVerificacion, setRequiereVerificacion] = useState(false);
    const [reenviando, setReenviando] = useState(false);
    const [reenviado, setReenviado] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setRequiereVerificacion(false);
        setReenviado(false);
        setLoading(true);

        try {
            const response = await fetch('/api/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({ email, password })
            });

            const data = await response.json();

            if (response.ok) {
                onLogin(data.usuario);
                navigate('/panel');
            } else {
                setError(data.error || 'Error al iniciar sesión');
                setRequiereVerificacion(!!data.requiere_verificacion);
                setShakeError(true);
                setTimeout(() => setShakeError(false), 500);
            }
        } catch (err) {
            setError('Error de conexión con el servidor');
            setShakeError(true);
            setTimeout(() => setShakeError(false), 500);
        } finally {
            setLoading(false);
        }
    };

    const handleReenviarVerificacion = async () => {
        setReenviando(true);
        try {
            await fetch('/api/registro/reenviar-verificacion', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            setReenviado(true);
        } catch (err) {
            setReenviado(true);
        } finally {
            setReenviando(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-shapes" aria-hidden="true">
                <span className="shape shape-1"></span>
                <span className="shape shape-2"></span>
                <span className="shape shape-3"></span>
            </div>

            <div className="login-wrapper">
                <div className="login-brand-panel">
                    <img
                        src="/isotipotransparente.png"
                        alt=""
                        className="brand-watermark"
                        aria-hidden="true"
                    />
                    <div className="brand-content">
                        <img
                            src="/Logotransparente.png"
                            alt="PsyTest"
                            className="login-brand-logo"
                        />
                        <h2>Evaluación psicométrica inteligente</h2>
                        <p>Administra candidatos, pruebas y resultados desde un solo lugar.</p>
                    </div>
                </div>

                <div className="login-card">
                    <div className="login-header">
                        <img
                            src="/Logotransparente.png"
                            alt="PsyTest"
                            className="logo-img"
                        />
                        <p className="login-subtitle">Inicia sesión para continuar</p>
                    </div>

                    <form onSubmit={handleSubmit} className={`login-form ${shakeError ? 'shake' : ''}`}>
                        <div className="login-field">
                            <input
                                id="login-email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder=" "
                                autoComplete="username"
                            />
                            <label htmlFor="login-email">Correo electrónico</label>
                        </div>

                        <div className="login-field">
                            <input
                                id="login-password"
                                type={showPassword ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder=" "
                                autoComplete="current-password"
                            />
                            <label htmlFor="login-password">Contraseña</label>
                            <button
                                type="button"
                                className="toggle-password"
                                onClick={() => setShowPassword((v) => !v)}
                                aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                tabIndex={-1}
                            >
                                {showPassword ? (
                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.8 21.8 0 0 1 5.06-6.94M9.9 4.24A10.4 10.4 0 0 1 12 4c7 0 11 8 11 8a21.8 21.8 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" strokeLinecap="round" strokeLinejoin="round"/>
                                        <line x1="1" y1="1" x2="23" y2="23" strokeLinecap="round"/>
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" strokeLinecap="round" strokeLinejoin="round"/>
                                        <circle cx="12" cy="12" r="3"/>
                                    </svg>
                                )}
                            </button>
                        </div>

                        {error && (
                            <div className="error-message" role="alert">
                                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10"/>
                                    <line x1="12" y1="8" x2="12" y2="12"/>
                                    <line x1="12" y1="16" x2="12.01" y2="16"/>
                                </svg>
                                {error}
                            </div>
                        )}

                        {requiereVerificacion && (
                            reenviado ? (
                                <p className="login-reenvio-hint">Te enviamos un nuevo enlace. Revisa tu correo.</p>
                            ) : (
                                <button
                                    type="button"
                                    className="btn-reenviar-verificacion"
                                    onClick={handleReenviarVerificacion}
                                    disabled={reenviando}
                                >
                                    {reenviando ? 'Enviando...' : 'Reenviar correo de verificación'}
                                </button>
                            )
                        )}

                        <button type="submit" disabled={loading} className="btn-login">
                            {loading ? (
                                <>
                                    <span className="login-spinner"></span>
                                    Iniciando sesión...
                                </>
                            ) : (
                                'Iniciar sesión'
                            )}
                        </button>
                    </form>

                    <div className="login-footer">
                        <small>© {new Date().getFullYear()} PsyTest · Sistema de Pruebas Psicométricas</small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
